import { render, staticRenderFns } from "./ModalReset2FA.vue?vue&type=template&id=0f636bf3&scoped=true&"
import script from "./ModalReset2FA.vue?vue&type=script&lang=js&"
export * from "./ModalReset2FA.vue?vue&type=script&lang=js&"
import style0 from "./ModalReset2FA.vue?vue&type=style&index=0&id=0f636bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f636bf3",
  null
  
)

component.options.__file = "ModalReset2FA.vue"
export default component.exports